// extracted by mini-css-extract-plugin
export default {"paragraph":"TestimonialJob_paragraph__hnJN8"};